import { render, staticRenderFns } from "./culturalSlider.vue?vue&type=template&id=128464b3&scoped=true"
import script from "./culturalSlider.vue?vue&type=script&lang=js"
export * from "./culturalSlider.vue?vue&type=script&lang=js"
import style0 from "./culturalSlider.vue?vue&type=style&index=0&id=128464b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128464b3",
  null
  
)

export default component.exports